
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shortcut/list",
      function () {
        return require("private-next-pages/shortcut/list/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shortcut/list"])
      });
    }
  